import { Popover } from 'antd';
import React, { FC, RefObject, useCallback, useState } from 'react';
import { useContentClick } from 'components/organisms/document/document-hooks/useContentClick';
import { useTextSelection } from 'components/organisms/document/document-hooks/useTextSelection';
import {
  setBalloonToolbarDetails,
  useDocuments,
} from 'components/organisms/document/document-store';
import { LinkForm } from 'components/organisms/document/parts/add-link-form';
import { PopupType } from 'data/documents';

export const CKLinkPopover: FC<{
  docRef: RefObject<HTMLDivElement>;
}> = ({ docRef }) => {
  const [state, documentStoreDispatch] = useDocuments();
  const [, setSelection] = useState<string>('');
  const [showLinkFormData, setLinkFormData] = useState({
    showEditForm: false,
    href: '',
  });
  const handleSelection = () => {
    // TODO: Support keyboard selection.
    const selctn = window.getSelection();

    setSelection(selctn?.toString() || '');
  };
  const handleClick = useCallback(
    (e: any) => {
      if (e.target.dataset.rocketlaneMentionType) {
        // Let the MentionService open the Drawer
        return;
      }
      setBalloonToolbarDetails(documentStoreDispatch, {
        type: PopupType.LinkForm,
        position: {
          x: e.x,
          y: e.y,
        },
      });
      setLinkFormData({
        showEditForm: true,
        href: e.target?.tagName.toLowerCase() === 'a' ? e.target?.href : '',
      });
    },
    [documentStoreDispatch],
  );

  const handleEveryClick = useCallback(
    (e: any) => {
      setBalloonToolbarDetails(documentStoreDispatch, {
        type: PopupType.BalloonToolbar,
        position: {
          x: e.x,
          y: e.y,
        },
      });
      setLinkFormData({
        showEditForm: false,
        href: '',
      });
    },
    [documentStoreDispatch],
  );

  useTextSelection(docRef, handleSelection);
  useContentClick(docRef, 'a', handleClick, handleEveryClick, state.editor);

  return (
    <Popover
      visible={state.balloonToolbarDetails.type === PopupType.LinkForm}
      content={
        <LinkForm
          edit={showLinkFormData.showEditForm}
          href={showLinkFormData.href}
        />
      }
    >
      <div
        style={{
          top: state.balloonToolbarDetails.position.y,
          left: state.balloonToolbarDetails.position.x,
          position: 'fixed',
        }}
      />
    </Popover>
  );
};
